export enum CommonFileType {
  Image = 'image',
  Audio = 'audio',
  Document = 'document',
  Sheet = 'sheet',
  Video = 'video',
  Markdown = 'markdown',
  Html = 'html',
  Text = 'text',
  Archive = 'archive',
  Other = 'other',

}
